import React from 'react'
import Login from '../../components/login/Login'

export default function LoginPage() {
  return (
    <div className="">
    <Login/>
  </div>
  )
}
